import React, { useState, useEffect, useRef } from "react";
import { Row, Button, Modal, Spinner } from "react-bootstrap";

import PdfViewer from "../PopUp/PdfViewer";
import {
  DOCUMENT,
  CONFIRMATION,
  DELETETOPIC,
  EDITPROFILEIMG,
  PARTICIPANTSUBMIT,
  GUIDE,
  EVENT_CHANGE,
  FEEDBACK,
  EDITSKILLS,
  UPLOAD_CV,
  REJECT_REASON,
  DECLARE_WINNERS,
} from "./ModalConstants";
import ORGANIZERGUIDE from "../Components/Resources/ORGANIZER  GUIDE.pdf";
import JURYGUIDE from "../Components/Resources/JURY GUIDE.pdf";
import Form from "react-bootstrap/Form";
import { ToastContainer, toast } from "react-toastify";
import { UploadFiles } from "../Components/services/apiFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faXmark,
  faTrashCan,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { Navigate, useNavigate } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { saveAs } from "file-saver";
import FeedbackForm from "./Feedback/FeedbackForm";
import { GetDownloadFile } from "../../src/Components/services/apiFunctions";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function PopupModal(props) {
  const [loader, setLoader] = useState(false);
  const [modalValues, setModalValues] = useState({});
  const [UploadPhotoVal, setUploadPhoto] = useState(null);
  const [loaderPhoto, setLoaderPhoto] = useState(false);
  const [file, setFile] = useState();
  const [NewPhotoPath, setNewPhotoPath] = useState();
  const [RoutingPage, setRoutingPage] = useState();
  const feedbackFormRef = useRef();

  const navigate = useNavigate();
  useEffect(() => {
    // GetUserCVs();
    const newModalValues = {};
    switch (props.type) {
      case CONFIRMATION:
        newModalValues.content = props.content;
        newModalValues.title = props.title;
        break;

      case DECLARE_WINNERS:
        newModalValues.title = props.title;
        break;

      case DOCUMENT:
        newModalValues.src = `${props?.content}#toolbar=0&navpanes=0&scrollbar=0&border=0&zoom=fitH`;
        //  newModalValues.src = `${url}#toolbar=0&navpanes=0&scrollbar=0&border=0&zoom=fitH`;
        newModalValues.title = props.title;
        break;

      case DELETETOPIC:
        newModalValues.content = props.content;
        newModalValues.title = props.title;

      case EDITPROFILEIMG:
        newModalValues.title = props.title;
        newModalValues.content = props?.content;
        break;
      case PARTICIPANTSUBMIT:
        newModalValues.title = props.title;
        newModalValues.content = props?.content;
        break;
      case GUIDE:
        newModalValues.title = props.title;
        newModalValues.content = props?.content;
        break;
      case EVENT_CHANGE:
        newModalValues.title = props.title;
        newModalValues.content = props?.content;
        break;
      case FEEDBACK:
        newModalValues.title = props.title;
        break;
      case EDITSKILLS:
        newModalValues.title = props.title;
        newModalValues.content = props.content;
        break;
      case UPLOAD_CV:
        newModalValues.title = props.title;
        newModalValues.content = props.content;
        break;

      case REJECT_REASON:
        newModalValues.title = props.title;
        break;

      default:
        break;
    }
    setModalValues(newModalValues);
  }, [props]);
  const Guide = [
    {
      Name: "Organizer",
      src: ORGANIZERGUIDE,
    },
    {
      Name: "Jury",
      src: JURYGUIDE,
    },
  ];
  //#region upload Image
  const UploadPhoto = async (e) => {
    const form = e.currentTarget;

    if (e.target.files.length != 0) {
      let type = "ProfileImage";
      // console.log("name", e.target.files[0].name)
      setUploadPhoto(e.target.value);
      const extension = e.target.files[0].name.split(".").pop().toLowerCase();
      const isSupported = ["png", "jpg", "jpeg"].includes(extension);

      if (isSupported) {
        setLoaderPhoto(true);

        if (e.target.files[0].size > 25000000) {
          toast.warning("Maximum File Size 25mb");
          setFile(null);
          return; // do not process the file if it exceeds the size limit
        }
        try {
          const response = await UploadFiles(e.target.files[0], type);
          if (response?.status == 200) {
            setLoaderPhoto(false);
            setFile(URL.createObjectURL(e.target.files[0]));
            setNewPhotoPath(response?.data);
          } else {
            setFile(null);
            setLoaderPhoto(false);
            setNewPhotoPath(null);
          }
        } catch (error) {
          setFile(null);
          setLoaderPhoto(false);
          setNewPhotoPath(null);
          console.log(error);
        }
      } else {
        setFile(null);
        setLoaderPhoto(false);
        setNewPhotoPath(null);
        setUploadPhoto("");
        toast.warning("Please Upload File type 'png,jpg,jpeg' Formats");
        return;
      }
    } else {
      setFile(null);
      setLoaderPhoto(false);
      setNewPhotoPath(null);
      setUploadPhoto("");

      return;
    }
  };
  console.log("file", file);
  //#endregion

  //   const GetUserCVs = async()=>{
  //     const response = await GetUserCV();
  //     if (response.status == 200) {
  //   console.log("response",response)
  //   const file = new Blob(
  //     [response.data],
  //     {type: 'application/pdf'});
  //     console.log("file",file)

  //     //Build a URL from the file
  //    const  fileURL = URL.createObjectURL(file);
  //    console.log("file",fileURL)
  //      seturl(fileURL)
  // //Open the URL on new Window
  //     // window.open(fileURL);
  //     }
  //   }
  const DownloadFile = async (url, Name) => {
    setLoader(true);
    let azurepath = url;
    let FileName = Name;
    const response = await GetDownloadFile(decodeURI(azurepath));

    if (response.status == 200) {
      saveAs(response.data, decodeURI(FileName));
      setLoader(false);
    }
  };
  return (
    <Modal
      {...props}
      size="lg"
      centered
       className={
        props.type === GUIDE
          ? "RulesCustompopmodel"
          : props.type === EDITSKILLS
          ? "CustomSkillModal"
          : props.type === REJECT_REASON
          ? "RejectReasonModal"
          : "Custompopmodel"
      }
    >
      <Modal.Header
        closeButton
        className={props.type == GUIDE ? "Rules" : "Documanetmodel-header"}
      >
        <Modal.Title className="modal-heading">
          {modalValues?.title}{" "}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className={
          props.type == GUIDE
            ? " conformationModalBody_rule"
            : "conformationModalBody"  
        }
        // className="conformationModalBody"
        // style={{ width: "fit-content", paddingTop: "0px", paddingBottom: "0px" }}
      >
        {loader && (
          <Spinner
            animation="border"
            role="status"
            className="custommodal-spinner-position"
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}
        {props.doctype == "PDF" && (
          <>
            <PdfViewer
              Name="pdf"
              url={modalValues?.src}
              //  url={url}
              onLoad={() => setLoader(false)}
              loading={loader}
            />
          </>
        )}
        {props.type === EDITSKILLS && modalValues.content}
        {props.type === UPLOAD_CV && modalValues.content}
        
        {props.type == CONFIRMATION && (
          <p className="modal-body">
            Are You Sure , You Want to Leave the {modalValues.content} ?
          </p>
        )}

        {props.type == DECLARE_WINNERS && (
          <p className="modal-body">
            Are you sure you want to declare the winners ?
          </p>
        )}

        {props.type == REJECT_REASON && (
          <>
            <Form.Label className="mb-1" style={{ fontSize: "13px", fontWeight: 500 }}>
              Reason
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              maxLength={100}
              placeholder="Enter reason"
              value={props.reason}
              onChange={(e) => props.setReason(e.target.value)}
            />
          </>
        )}

        {props.type == DELETETOPIC && (
          <p className="DeletionModalBody">
            Are You Sure , You Want to Delete the {modalValues.content}?
          </p>
        )}

        {props.type == EDITPROFILEIMG && (
          <>
            <div className="text-center">
  {file || modalValues.content ? (
    <img
      src={file ? file : `data:image/jpeg;base64,${modalValues.content}`}
      alt="Profile"
      className="Preview-picture-edit-popup"
    />
  ) : (
    <FontAwesomeIcon
      icon={faUser}
      className="popup-default-icon"
    />
  )}
</div>


            <div className="mt-3">
              <Form.Control
                type="file"
                value={UploadPhotoVal}
                accept="image/png,image/jpeg,image/jpg"
                disabled={loaderPhoto}
                id="edit-image"
                className={loaderPhoto ? "loading" : null}
                onChange={UploadPhoto}
              />
            </div>
          </>
        )}
        {props.type == PARTICIPANTSUBMIT && (
          <>
            <div>
              <p>Please select a button below, Where you want to redirect. </p>
            </div>
            <div style={{ textAlignLast: "center" }}>
              <Button
                style={{
                  marginRight: "18px",
                  height: "40px",
                  width: "25%",
                }}
                className="hpe-btn primary-btn-hpe btn-sm"
                onClick={() => {
                  props.onHide();
                  navigate("/profile");
                }}
              >
                {/* <FontAwesomeIcon icon={faUser} /> */}
                Profile
              </Button>
              <Button
                style={{
                  marginRight: "18px",
                  height: "40px",
                }}
                className="hpe-btn primary-btn-hpe btn-sm"
                onClick={() => {
                  props.onHide();
                  navigate("/participant-topics?filter=All");
                }}
              >
                {/* <FontAwesomeIcon icon={faUser} /> */}
                Participant Topic
              </Button>
            </div>
            {/* <hr className=" verticleline"></hr> */}
            {/* <Form>
              <Form.Check
                inline
                label="Profile"
                name="Profile"
                type='radio'
                id={`Profile`}
                value="/profile"
                onChange={e => setRoutingPage(e.target.value)}
              />
              <Form.Check
                inline
                label="Participant Topics"
                name="Participant Topics"
                type='radio'
                id={`Participant Topics`}
                value="/participant-topics?filter=All"
                onChange={e => setRoutingPage(e.target.value)}
              />
            </Form> */}
          </>
        )}
        {props.type == FEEDBACK && <FeedbackForm ref={feedbackFormRef} />}
        {props.type == GUIDE && (
          <>
            <Accordion
              flush
              className="homepage-accordianbg"
              defaultActiveKey="0"
            >
              {Guide.map((ele, index) => (
                <Accordion.Item eventKey={index}>
                  <Accordion.Header>
                    <p className="Rules_heading"> {ele.Name}</p>
                    {/* <span>
                      <FontAwesomeIcon
                        icon={faDownload}
                        onClick={() => { saveAs(ele.src, ele.Name) }}
                      />
                    </span> */}
                  </Accordion.Header>

                  <Accordion.Body>
                    {/* {console.log(ele.Name)} */}
                    <Row className="feature-top12">
                      <div className="section-header">
                        <>
                          <div className="popup_downloaddiv">
                            <span
                              onClick={() => {
                                saveAs(ele.src, ele.Name);
                              }}
                              className="popup_download"
                            >
                              Download
                            </span>

                            <FontAwesomeIcon
                              onClick={() => {
                                saveAs(ele.src, ele.Name);
                              }}
                              className="poniter downloadicon"
                              icon={faDownload}
                            />
                          </div>
                          <Row className="my-4">
                            <PdfViewer
                              Name={ele.Name}
                              url={ele.src}
                              //  url={url}
                              onLoad={() => setLoader(false)}
                              loading={loader}
                            />
                          </Row>
                        </>
                      </div>
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>

            {/* <p>hii</p> */}
          </>
        )}
        {props.type == EVENT_CHANGE && (
          <p className="modal-body">
            Are You Sure , You Want to change the Event to {modalValues.content}
            ?
          </p>
        )}
      </Modal.Body>
      <Modal.Footer className="Conformationmodal">
        <Row
          className={
            props.type == GUIDE
              ? "Rulesmodal-Footer-width"
              : "modal-Footer-width"
          }
        >
          <div className="col-md-12 modal-cancelbtn">
            {(props.type == CONFIRMATION ||
              props.type == DECLARE_WINNERS ||
              props.type == EVENT_CHANGE ) && (
                <Button
                  style={{ marginRight: "5px" }}
                  className="hpe-btn primary-btn-hpe btn-sm"
                  onClick={() => {
                    props.onHide();
                    props.ok();
                  }}
                >
                  <FontAwesomeIcon icon={faCheck} /> Yes
                </Button>
              )}
            {props.type == REJECT_REASON && (
              <Button
                style={{ marginRight: "5px" }}
                className="hpe-btn primary-btn-hpe btn-sm"
                disabled={!props.reason?.trim()}
                onClick={() => {
                  props.onHide();
                  props.ok();
                }}
              >
                Submit
              </Button>
            )}
            {props.type == DELETETOPIC && (
              <Button
                style={{ marginRight: "5px" }}
                className="hpe-btn delete-btn-hpe btn-sm"
                onClick={() => {
                  props.onHide();
                  props.ok();
                }}
              >
                <FontAwesomeIcon icon={faTrashCan} /> Delete
              </Button>
            )}
            {props.type === EDITSKILLS && 
                props.footerButtons
            }
            {props.type === UPLOAD_CV && 
                props.footerButtons
            }
            {props.type == EDITPROFILEIMG && (
              <Button
                style={{ marginRight: "5px", Padding: "14px" }}
                className="hpe-btn primary-btn-hpe btn-sm"
                onClick={() => {
                  props.onHide();
                  props.ok(NewPhotoPath);
                }}
                disabled={loaderPhoto}
              >
                Save
              </Button>
            )}
            {props.type == PARTICIPANTSUBMIT && <></>}
            {props.type == FEEDBACK && (
              <>
                <Button
                  style={{ marginRight: "5px" }}
                  className="hpe-btn primary-btn-hpe btn-sm"
                  onClick={async () => {
                    const result =
                      await feedbackFormRef.current.feedbackSubmit();
                    if (result.validation) {
                      props.onHide();
                      props.ok(result.data);
                    }
                  }}
                  disabled={loader}
                >
                  Submit
                </Button>
                <Button
                  className="hpe-btn primary-outline-btn-hpe btn-sm"
                  onClick={() => {
                    feedbackFormRef.current.feedbackReset();
                  }}
                  disabled={loader}
                >
                  Reset
                </Button>
              </>
            )}
            {props.type !== FEEDBACK && props.type !== GUIDE && props.type !== EDITSKILLS && props.type !== UPLOAD_CV &&(
              <Button
                className="hpe-btn primary-outline-btn-hpe btn-sm"
                onClick={() => {
                  if (props.type === EDITPROFILEIMG) {
                    setFile(null);
                    setLoaderPhoto(false);
                    setNewPhotoPath(null);
                    setUploadPhoto("");
                  }

                  props.onHide();
                }}
              >
                Cancel
              </Button>
            )}
            {/* {props.type == RULES && (
              <Button
                className="hpe-btn primary-outline-btn-hpe btn-sm"
                onClick={() => {
                

                  props.onHide();
                }}
              >
                <FontAwesomeIcon icon={faXmark} /> Cancel
              </Button>
            )} */}
          </div>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}
export default PopupModal;
